// extracted by mini-css-extract-plugin
export default {"HeroImage":"HeroImage_HeroImage__Rr6Do","HeroImage__cover":"HeroImage_HeroImage__cover__gDRcg"};